<template>
  <div class="mission-tips-in-page-wrapper">
    <div
      class="mission-tips-in-page"
      v-show="showThisTips"
      :class="{ 'mission-tips-in-page-hasShowGlobalBanner': showGlobalBanner }"
      @click="linkToTask"
    >
      <img src="~/assets/img/registe-success-v2/mission_tips.svg" alt="" />
      <MissionTipsIcon></MissionTipsIcon>
      <!-- <nuxt-link :to="link" v-if="link && content" class="mission-tips-in-page-content">
        {{ content }}
      </nuxt-link> -->
      <div class="mission-tips-in-page-content">{{ content || task?.currentDesc.content }}</div>
      <r-icon
        name="icon-actions_navigation_close"
        class="mission-tips-in-page-close"
        @click.stop="show = false"
      />
    </div>
  </div>
</template>

<script>
import { axiosClient } from '~/common/js/axios';
import { transLang, isLoginedToken } from '~/common/js/utils';
import { useStore } from '~/common/js/patch';
import { handleLotteryResp, MissionTaskStatusEnum, useMultipleMissionAction } from '@/utils/missionCenter';
import { track, SENSOR_EVENT_NAME } from '~/frontend-shared/helper/sensor';
import MissionTipsIcon from '~/assets/img/registe-success-v2/mission_tips.svg';

export default {
  name: 'MissionTipsInPage',
  components: {
    MissionTipsIcon,
  },
  props: {
    missionType: {
      type: [Number, String],
      default: '',
    },
    content: {
      type: String,
      default: '',
    },
    link: {
      type: String,
      default: '',
    },
  },
  setup(props) {
    const sensorNameMap = {
      3: SENSOR_EVENT_NAME.Registry_Deposit.web_task_reminder_deposit, // 充值入口事件
      4: SENSOR_EVENT_NAME.Registry_Deposit.web_task_reminder_gateway, // 三方
      5: SENSOR_EVENT_NAME.Registry_Deposit.web_task_reminder_p2p,
      6: SENSOR_EVENT_NAME.Registry_Deposit.web_task_reminder_card,
    };

    const show = ref(true);
    const task = ref(null);
    const showThisTips = computed(() => {
      return (props.content || task.value) && !isDeposit.value && show.value;
    });

    const store = useStore();
    const locale = computed(() => store.state.locale);
    const showGlobalBanner = computed(() => store.state.showGlobalBanner);

    const { linkFormat, storeCommit } = useMultipleMissionAction({ data: {} });

    const isDeposit = ref(false);
    const getIsDepositState = async () => {
      if (!isLoginedToken()) return;
      let res = await axiosClient({
        url: '/gw-api/mission/user/isDeposit',
        cache: false,
        method: 'GET',
      });
      if (res.success) {
        isDeposit.value = res.data;
      }
    };

    const getTasks = async () => {
      let res = await axiosClient({
        url: '/gw-api/mission/homeShowMission/list',
        cache: false,
        method: 'GET',
        params: {
          deviceType: 2,
          language: transLang(locale.value),
        },
        headers: {
          noMessage: true,
        },
      });

      if (res.success) {
        const notShowStateList = [3, 4, 8];
        task.value = res.data
          .filter((item) => !notShowStateList.includes(item.state) && item.missionType === props.missionType)
          .map((item) => {
            const d = { ...item };
            const { content, type } = linkFormat({
              missionRule: item.missionRule,
            });
            d.link = content;
            d.type = type;
            d.currentDesc = d.desc
            return d;
          })[0];

        // if (task.value) {
        //   console.log('task', task.value);
        //   show.value = true;
        // }
      }
    };

    const linkToTask = () => {
      // const item = task.value;
      // if (!item) {
      //   return;
      // }

      if (sensorNameMap[props.missionType]) {
        track(sensorNameMap[props.missionType]);
      }

      // if (item.type === 'in') {
      //   window.location.href = item.link;
      // } else if (item.type === 'out') {
      //   window.open(item.link);
      // } else if (item.type === 'StoreCommit') {
      //   storeCommit(item.link);
      // }
    };

    onMounted(() => {
      if (props.missionType && !props.content) {
        getIsDepositState();
        getTasks();
      }
      // if (props.content) {
      //   show.value = true;
      // }
    });

    return {
      linkToTask,
      showGlobalBanner,
      task,
      showThisTips,
      show,
    };
  },
};
</script>

<style lang="less" scoped>
.mission-tips-in-page-wrapper {
  width: 100%;
  .mission-tips-in-page {
    background-color: rgba(19, 194, 194, 0.1);
    padding: 11px 0;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 12px;
    font-size: 14px;
    width: 100%;

    &.mission-tips-in-page-hasShowGlobalBanner {
      padding-top: 32px;
    }

    .mission-tips-in-page-close {
      cursor: pointer;
      color: rgba(105, 113, 117, 1);
      font-size: 12px !important;
    }

    .mission-tips-in-page-content {
      // cursor: pointer;
    }
  }
}
</style>
